// components/Header.js
import React from "react";
import { Link } from "react-scroll";
import "./Header.css";
const logo = process.env.PUBLIC_URL + '/store_icon.png';

const Header = () => {
  return (
    <header className="floating-header">
      <nav className="nav-left">
        <Link
          to="showcase"
          smooth={true}
          duration={500}
          offset={0}
          className="nav-link"
        >
          Facial Recognition
        </Link>
        <Link
          to="showcase-alt"
          smooth={true}
          duration={500}
          offset={0}
          className="nav-link"
        >
          Video Call
        </Link>
      </nav>

      <img src={logo} alt="MusterTaker Logo" className="logo" />

      <nav className="nav-right">
        <Link
          to="hardware"
          smooth={true}
          duration={500}
          offset={0}
          className="nav-link"
        >
          Hardware
        </Link>
        <Link
          to="contact"
          smooth={true}
          duration={500}
          offset={0}
          className="nav-link"
        >
          Contact Us
        </Link>
      </nav>
    </header>
  );
};

export default Header;
